/* ============================================================
   Chi siamo — blocco immersivo (video scroll + step) e tab contatti
   • Un solo video, due layer (sfondo sfocato + primo piano nitido) sincronizzati.
   • Caricato come blob: seek fluido legato allo scroll anche su dev server.
   • 3 testi (step) che si susseguono in base al progresso di scroll.
   • Tab scheda contatti: Scrivici / Prenota una consulenza.
   • Nessuna libreria. prefers-reduced-motion: video statico, step tutti visibili.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  /* ---------- Blocco immersivo (scrub + step) ---------- */
  function initImmersive(section) {
    if (section.__scmImm) return; section.__scmImm = true;
    var fg = section.querySelector("[data-about-scroll]");
    var bg = section.querySelector("[data-about-scroll-bg]");
    if (!fg) return;
    var videos = bg ? [fg, bg] : [fg];
    var steps = [].slice.call(section.querySelectorAll(".scm-about__step"));
    var dots = [].slice.call(section.querySelectorAll(".scm-about__dots span"));

    var dur = 0, ready = false, cur = 0, target = 0, raf = null, active = -1;

    function setStep(i) {
      if (i === active) return; active = i;
      steps.forEach(function (s, si) { s.classList.toggle("is-active", si === i); });
      dots.forEach(function (d, di) { d.classList.toggle("is-on", di === i); });
    }
    function ease() {
      raf = null;
      cur += (target - cur) * 0.18;
      if (Math.abs(target - cur) < 0.0008) cur = target;
      if (ready && dur) {
        var t = clamp(cur, 0, 1) * dur;
        videos.forEach(function (v) { try { v.currentTime = t; } catch (e) {} });
      }
      if (Math.abs(target - cur) > 0.0004) raf = window.requestAnimationFrame(ease);
    }
    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var top = section.getBoundingClientRect().top + y;
      var total = section.offsetHeight - vh;
      var p = total > 0 ? clamp((y - top) / total, 0, 1) : 0;
      if (ready) { target = p; if (!raf) raf = window.requestAnimationFrame(ease); }
      // step: 3 fasce
      var n = steps.length || 1;
      setStep(Math.min(n - 1, Math.floor(p * n - 0.0001 < 0 ? 0 : p * n)));
    }

    function activate() {
      if (ready) return;
      dur = fg.duration || 0;
      if (!dur || !isFinite(dur)) return;
      ready = true;
      videos.forEach(function (v) {
        try {
          var pr = v.play && v.play();
          if (pr && pr.then) pr.then(function () { try { v.pause(); } catch (e) {} }).catch(function () {});
          else { try { v.pause(); } catch (e) {} }
        } catch (e) {}
      });
      onScroll();
    }

    setStep(0);
    if (reduce) { setStep(0); steps.forEach(function (s) { s.classList.add("is-active"); }); return; }

    fg.addEventListener("loadeddata", activate);
    fg.addEventListener("canplay", activate);

    // Carica una volta come blob, condiviso dai due layer (sfondo + primo piano).
    var srcEl = fg.querySelector("source");
    var url = (srcEl && srcEl.getAttribute("src")) || fg.getAttribute("src") || "";
    if (url && window.fetch) {
      fetch(url).then(function (r) { if (!r.ok) throw 0; return r.blob(); })
        .then(function (b) {
          var obj = URL.createObjectURL(b);
          videos.forEach(function (v) { try { v.src = obj; v.load(); } catch (e) {} });
        })
        .catch(function () { videos.forEach(function (v) { try { v.load(); } catch (e) {} }); });
    } else { videos.forEach(function (v) { try { v.load(); } catch (e) {} }); }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  /* ---------- Tab scheda contatti ---------- */
  function initTabs(card) {
    if (card.__scmTabs) return; card.__scmTabs = true;
    var tabs = [].slice.call(card.querySelectorAll(".scm-about__tab"));
    var panels = [].slice.call(card.querySelectorAll(".scm-about__panel"));
    function show(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-tab") === name;
        t.classList.toggle("is-active", on); t.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (p) {
        var on = p.getAttribute("data-panel") === name;
        p.classList.toggle("is-active", on); if (on) { p.removeAttribute("hidden"); } else { p.setAttribute("hidden", ""); }
      });
    }
    tabs.forEach(function (t) { t.addEventListener("click", function () { show(t.getAttribute("data-tab")); }); });
    // bottoni esterni (es. nello step 3) che aprono un tab specifico
    [].slice.call(document.querySelectorAll("[data-open-tab]")).forEach(function (btn) {
      btn.addEventListener("click", function () { show(btn.getAttribute("data-open-tab")); });
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll(".scm-about__immersive")).forEach(initImmersive);
    [].slice.call(document.querySelectorAll("[data-about-tabs]")).forEach(initTabs);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
